import { Injectable, inject } from '@angular/core';
import { ProspectService } from './prospect-service';

const DEFAULT_COLOR = '#8c8c8c';

@Injectable({ providedIn: 'root' })
export class StageColorService {
  private readonly prospectService = inject(ProspectService);

  private colorByMainName: Record<string, string> = {};
  private colorBySubId: Record<number, string> = {};
  private colorBySubName: Record<string, string> = {};
  private mainStages: { name: string; color: string }[] = [];
  private loadPromise: Promise<void> | null = null;

  ensureLoaded(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = this.load();
    }
    return this.loadPromise;
  }

  getByMainName(name: string): string {
    return this.colorByMainName[name.toLowerCase()] ?? DEFAULT_COLOR;
  }

  getBySubId(id: number): string {
    return this.colorBySubId[id] ?? DEFAULT_COLOR;
  }

  getByName(name: string): string {
    const key = name.toLowerCase();
    return (
      this.colorByMainName[key] ?? this.colorBySubName[key] ?? DEFAULT_COLOR
    );
  }

  getMainStageList(): { name: string; color: string }[] {
    return this.mainStages;
  }

  private async load(): Promise<void> {
    try {
      const stages = await this.prospectService.stages();
      if (!stages) return;
      for (const main of stages) {
        const parentColor = main.datosJson?.color;
        if (main.mainStages && parentColor) {
          this.colorByMainName[main.mainStages.toLowerCase()] = parentColor;
          this.mainStages.push({ name: main.mainStages, color: parentColor });
        }
        if (main.stages) {
          for (const sub of main.stages) {
            const subColor =
              sub.datosJson?.color ?? parentColor ?? DEFAULT_COLOR;
            if (sub.id != null) {
              this.colorBySubId[sub.id] = subColor;
            }
            if (sub.description) {
              this.colorBySubName[sub.description.toLowerCase()] = subColor;
            }
          }
        }
      }
    } catch {
      /* colores quedan vacíos; consumidores obtienen DEFAULT_COLOR */
    }
  }
}
